import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { BarChart } from "@mui/x-charts/BarChart";
import {
  Container,
  Typography,
  createTheme,
  ThemeProvider,
  useTheme,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { MaterialReactTable } from "material-react-table";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

import { UrlApiEnvasado } from "../../../services/apirest";

// ICONOS
import CircularProgress from '@mui/material/CircularProgress';

// PARA EL IDIOMA DEL CALENDARIO
import "dayjs/locale/es";
import dayjs from "dayjs";

function TableGrafica4({ datosChoferVentas, anio, setAnio }) {
  const [loading, setLoading] = useState(true); // Estado de carga

  const [registrosChofer, setRegistrosChofer] = useState();

  // ------------------------------------------------------------------------

  const [selectedYear, setSelectedYear] = useState(anio);
  // CAMBIO DE FECHA
  const handleYearChange = (newDate) => {
    if (dayjs(newDate).isValid()) {
      setSelectedYear(dayjs(newDate).year().toString());
    }
  };

  console.log("AÑO SELECCIONADO: ", selectedYear);

  // ------------------------------------------------------------------------
  // AGREGAR OBTENER DE CHOFERES
  const obtenerRegistrosChoferes = () => {
    setLoading(true); // Iniciar carga

    fetch(
      UrlApiEnvasado +
        "/envasado/choferes/chofer/" +
        datosChoferVentas.id +
        "/anio/" +
        selectedYear
    )
      .then((data) => data.json())
      .then((data) => {
        setRegistrosChofer(data);
        setLoading(false); // Finalizar carga
      })
      .catch((error) => {
        console.error("Error al obtener las ventas de los choferes:", error);
        setLoading(false); // Finalizar carga en caso de error
      });
  };

  useEffect(() => {
    obtenerRegistrosChoferes();
  }, [selectedYear]);

  console.log("REGISTROS CHOFER: ", registrosChofer);

  // ------------------------------------------------------------------------

  const columns = useMemo(
    () => [
      {
        header: "Mes",
        accessorKey: "mes",
        size: 100,
      },
      {
        header: "Dia",
        accessorKey: "dia",
        size: 30,
      },
      {
        header: "Hora",
        accessorKey: "hora",
        size: 60,
      },
      {
        header: "Sucursal",
        accessorKey: "sucursal_nombre",
        size: 100,
      },
      {
        header: "Movil",
        accessorKey: "movil_nombre",
        size: 100,
      },
      {
        header: "Cliente",
        accessorKey: "cliente_nombre",
        size: 100,
      },
      {
        header: "Tipo de Comprobante",
        accessorKey: "descripcion",
        size: 100,
      },
      {
        header: "Envase",
        accessorKey: "envase",
        size: 150,
      },
      {
        header: "Peso",
        accessorKey: "peso",
        size: 100,
        Cell: ({ cell }) => `${cell.getValue()} kg`, // Agregar "kg" al final del valor
      },
      {
        header: "Cant.",
        accessorKey: "frr_cantidad",
        size: 70,
      },
      {
        header: "Peso Total Vendido",
        accessorKey: "peso_total_vendido",
        size: 200,
        Cell: ({ cell }) => `${cell.getValue()} kg`, // Agregar "kg" al final del valor
      },
    ],
    []
  );

  //*************************************************************************************************************************************/

  // ESTILO PARA LA TABLA
  const globalTheme = useTheme();

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)", 
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      size: 95,
    },
  };

  const tableHeadCellProps = {
    align: "left", // Titulos de la tabla
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    grouping: ["mes", "dia"],
    sorting: [
      {
        id: "hora",
        desc: false,
      },
    ],
    pagination: { pageIndex: 0, pageSize: 15 },
  };

  console.log("ESTADO DE LOADING: ", loading);

  return (
    <div>
      <Container maxWidth="xl" mt={1}>
        <Box mb={4}>
       

          {/* {registrosChofer ? ( */}
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <CircularProgress />
            </div>
          ) : (
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableGrouping
                enableColumnActions={true}
                positionActionsColumn="last" // posicion de la columna de acciones al final
                enableColumnFilters={false} //desactiva filtros x columna
                enableHiding={false}
                enableDensityToggle={false}
                displayColumnDefOptions={displayColumnDefOptions}
                muiTableHeadCellProps={tableHeadCellProps}
                layoutMode="grid"
                columns={columns}
                data={registrosChofer}
                initialState={initialState}
                renderTopToolbarCustomActions={() => (
                  <Grid container>
                    <Grid item xs={5}>
                      <Typography
                        color="inherit"
                      >
                        <b>Vendedor:</b> {datosChoferVentas.vendedor_nombre}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="es"
                      >
                        <DemoContainer components={["DatePicker"]}>
                          <DatePicker
                            views={["year"]}
                            label="Año"
                            value={dayjs(`${selectedYear}`)}
                            onChange={(newDate) => handleYearChange(newDate)}
                            slotProps={{ textField: { size: "small" } }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                )}
              />
            </ThemeProvider>
          )}
        </Box>
      </Container>
    </div>
  );
}

export default TableGrafica4;
